var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"space-y-4 pb-4"},[_c('PersonalInformationSection'),_c('PrivacyAndSecuritySection'),_c('Restricted',{attrs:{"permission":"user.request-to-be-admin"}},[_c('RequestUpgradeRoleSection')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }